/* globals $ */

import Cookies from "js-cookie";

class AppCookies {
  constructor() {
    this.$popup = $("#cookies-popup");
    let settings = Cookies.get("cookies-settings");
    if (settings) {
      this.settings = JSON.parse(settings);
    }
    this.$modal = $("#cookies-info");
    $(".js-cookie-settings").on("click", (e) => {
      e.preventDefault();
      this.$modal.fadeIn();
    });
    this.initModal();
    this.initPopup();
    console.log("Cookies initialised");
  }

  initPopup() {
    this.$popup.find(".js-approve").on("click", (e) => {
      e.preventDefault();
      this.$modal.find("[type=checkbox]").prop("checked", true);
      this.saveCookieSettings();
    });

    this.$popup.find(".js-reject").on("click", (e) => {
      e.preventDefault();
      this.$modal.find("[type=checkbox]").prop("checked", false);
      this.saveCookieSettings();
    });

    if (!this.settings) {
      this.$popup.fadeIn();
    }
  }

  initModal() {
    this.$modal.find(".js-close").click((e) => {
      e.preventDefault();
      this.$modal.fadeOut("fast");
    });

    this.$modal.find(".js-uncheck-all").click((e) => {
      e.preventDefault();
      this.$modal.find("[type=checkbox]").prop("checked", false);
    });

    this.$modal.find("form").submit((e) => {
      e.preventDefault();
      this.saveCookieSettings();
    });

    if (this.settings) {
      $.each(this.$modal.find("[type=checkbox]"), (i, item) => {
        let name = $(item).attr("name");
        if (this.settings[name] ?? false) {
          $(item).prop("checked", true);
        }
      });
    } else {
      this.$modal.find("[type=checkbox]").prop("checked", true);
    }
  }

  saveCookieSettings() {
    this.settings = {};
    $.each(this.$modal.find("[type=checkbox]"), (i, item) => {
      this.settings[$(item).attr("name")] = $(item).prop("checked") ? true : false;
    });
    this.setCookie("cookies-settings", JSON.stringify(this.settings));
    window.location.reload();
  }

  setCookie(name, value, daysExpiry = 365, checkConsent = false) {
    if (checkConsent && (!this.settings || !this.settings[checkConsent])) {
      return;
    }
    Cookies.set(name, value, { expires: daysExpiry });
  }

  getCookie(name) {
    return Cookies.get(name);
  }

  checkConsent(category) {
    if (this.settings && (this.settings[category] ?? false)) {
      return true;
    }
    return false;
  }
}

export { AppCookies };
